import service from "@/store/services/third-party-services-service";

export const state = {
  list: {},
  thirdPartyService: {},
  meta: {},
};

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, thirdPartyService) => {
    state.thirdPartyService = thirdPartyService;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((thirdPartyService) => {
      commit("SET_RESOURCE", thirdPartyService);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((thirdPartyService) => {
      commit("SET_RESOURCE", thirdPartyService);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((thirdPartyService) => {
      commit("SET_RESOURCE", thirdPartyService);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  thirdPartyService: (state) => state.thirdPartyService,
  dropdown: (state) => {
    return state.list.map((thirdPartyService) => ({
      id: thirdPartyService.id,
      name: thirdPartyService.name,
    }));
  },
};

const thirdPartyServices = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default thirdPartyServices;
